import { Type } from "class-transformer";
import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class EnforcementTabletResponse {
  id!: string;

  @observable
  hostname!: string;

  @observable
  alias!: string;

  @observable
  isEnabled!: boolean;

  @observable
  isDeleted!: boolean;

  @observable
  createdBy!: string;

  @observable
  updatedBy!: string;

  @observable
  @Type(() => Date)
  createdAt!: Date;

  @observable
  @Type(() => Date)
  updatedAt!: Date;
}

export const EnforcementTabletValidationRules: EntityValidationRules<EnforcementTabletResponse> = {
  hostname: {
    required: true,
    isLength: {
      min: 0,
      max: 70,
    },
  },
  alias: {
    required: true,
    isLength: {
      min: 0,
      max: 30,
    },
  },
};
